import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSpring, animated } from 'react-spring'
import { motion } from 'framer-motion'
import start_phone from '../img/parts/start_phone.png'
import start_pc from '../img/parts/start_pc.png'
import Background from './parts/Background'

interface AnimatedLinkProps {
  opacity: number
  transform: string
}

const Start = () => {
  const [clicked, setClicked] = useState(false)
  const navigate = useNavigate()

  const handleAnimationEnd = () => {
    // アニメーション終了時に画面遷移
    navigate('/nemo2024/Home')
  }

  const { transform, opacity } = useSpring<AnimatedLinkProps>({
    transform: clicked ? 'scale(8.0)' : 'scale(1)',
    opacity: clicked ? 0.0 : 1,
    config: { tension: 100, friction: 20, duration: 600 },
    onRest: handleAnimationEnd,
  })

  // クリックイベントハンドラーの型を修正
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // アニメーションを開始
    setClicked(true)
  }

  return (
    // npm install framer-motion
    <motion.div
      initial={{ scale: 1.5, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 1, opacity: 0 }}
      transition={{ duration: 0.5 }}
      className=" relative overflow-hidden"
    >
      <Background />
      <animated.div
        style={{ transform, opacity }}
        onClick={handleClick}
        className="zoom-out-image flex h-screen cursor-pointer items-center  justify-center"
      >
        <Link
          to="/nemo2024/home"
          style={{ pointerEvents: 'none' }}
          className="transform transition-transform duration-300 hover:scale-105"
        >
          <div className=" ">
            {/* For large screens */}
            <div className="hidden lg:block xl:block">
              <img
                src={start_pc}
                alt="startImg"
                className=" bottom-0 left-1/2 h-screen  object-cover"
                // className=" bottom-0 left-1/2 h-screen -translate-x-1/2 transform object-cover"
              />
              {/* <img
                src={start_pc_background}
                alt="background"
                className=" h-screen w-screen object-bottom"
              /> */}
            </div>

            <div className="md:block lg:hidden xl:hidden">
              <img
                src={start_phone}
                alt="startImg"
                className=" left-1/2 top-1/2 w-screen  object-cover"
                // className="absolute left-1/2 top-1/2 w-screen -translate-x-1/2 -translate-y-1/2 transform object-cover"
              />
              {/* <img
                src={start_pc_background}
                alt="background"
                className="h-screen w-screen object-cover"
              /> */}
            </div>
          </div>
        </Link>
      </animated.div>
    </motion.div>
  )
}

export default Start
// {/* <div className="relative  overflow-hidden">
//   <div className="hidden lg:block xl:block">
//     <img
//       src={start_pc}
//       alt="startImg"
//       className="absolute bottom-0 left-1/2 h-full w-full -translate-x-1/2 transform object-cover"
//       // className="absolute left-0 top-0 h-full w-full object-cover"
//     />
//     <img
//       src={start_pc_background}
//       alt="background"
//       className=" h-screen w-screen "
//     />
//   </div>

//   <div className=" md:block lg:hidden xl:hidden">
//     <img
//       src={start_phone}
//       alt="startImg"
//       className="absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 transform object-cover"
//     />
//     <img
//       src={start_pc_background}
//       alt="background"
//       className="h-screen w-screen "
//     />
//   </div>
// </div> */}
